export default "__VITE_ASSET__DvckyOtf__"